<ion-header class="ion-header-set-password">
  <ion-toolbar>
    <div class="header-grid">
      <div class="main-logo-sec">
        <img src="../../../assets/images/eZintegration-black-logo.svg">
      </div>
    </div>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="container">
    <div class="bg-grid">
      <div class="grid-container">
        <div class="grid-content">
          <div class="company-logo-sec">
            <img src="../../../assets/images/bizdata-header-logo.png">
          </div>
          <div class="main-logo-sec">
              <img src="../../../assets/images/eZintegration-black-logo.svg">
          </div>
          <span class="bg-sub-content"> Set Your Password </span>
          <mat-card>
            <mat-card-content>
              <div class="views-content">
                <span class="content-1"> Enter new Password for {{regemail}}. </span>
              </div>          
              <div class="form-container">
                <form [formGroup]="setPasswordform" (ngSubmit)="onSetPasswordSubmit()">
                  <!-- <div class="error-validation" *ngIf="submitted && (setPasswordControls.newPassword.hasError('required') || setPasswordControls.newPassword.hasError('minlength') || setPasswordControls.newPassword.hasError('hasNumber') || setPasswordControls.newPassword.hasError('hasSmallCase') || setPasswordControls.newPassword.hasError('hasSpecialCharacters'))">
                    <p>Make sure to include atleast</p>
                    <label>
                      8 characters.
                    </label>
                    <label>
                      1 Special Character. 
                    </label>
                    <label>
                      1 Letter. 
                    </label>
                    <label>
                      1 number. 
                    </label>
                  </div> -->
                  <!-- <span class="material-icons">
                        error_outline
                      </span> -->
                  <mat-form-field appearance="outline">
                    <mat-label>New Password</mat-label>
                      <input [type]="hide ? 'password' : 'text'" id="set_password_new" formControlName="newPassword" matInput placeholder="New Password" required>
                      <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                      <!-- <mat-error *ngIf="setPasswordControls.newPassword.hasError('required') || setPasswordControls.newPassword.hasError('minlength') || setPasswordControls.newPassword.hasError('hasNumber') || setPasswordControls.newPassword.hasError('hasSmallCase') || setPasswordControls.newPassword.hasError('hasSpecialCharacters')">Password should have 8 characters, 1 Capital Letter, 1 Number, and 1 Special Characters. </mat-error> -->
                      <mat-error *ngIf="setPasswordControls.newPassword.hasError('required') || setPasswordControls.newPassword.hasError('minlength') || setPasswordControls.newPassword.hasError('hasNumber') || setPasswordControls.newPassword.hasError('hasUpperCase') || setPasswordControls.newPassword.hasError('hasSmallCase') || setPasswordControls.newPassword.hasError('hasSpecialCharacters')">Password must have atleast 8 Characters, 1 Number, 1 Special Character, 1 Lowercase Character, 1 Upper Character.</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Confirm Password</mat-label>
                      <input type="password" id="set_password_confirm" formControlName="confirmPassword" matInput placeholder="Confirm Password" required>
                      <!-- <mat-error *ngIf="submitted && setPasswordControls.confirmPassword.hasError('required')">Password Required. </mat-error> -->
                      <mat-error *ngIf="setPasswordControls.confirmPassword.hasError('NoPassswordMatch')">Password do not match. </mat-error>
                    </mat-form-field> 
    
                  <!-- <mat-form-field appearance="outline">
                    <mat-label>Confirm Password</mat-label>
                    <input type="password" formControlName="confirmPassword" matInput placeholder="Confirm Password" required>
                    <mat-error *ngIf="submitted && setPasswordControls.confirmPassword.hasError('NoPassswordMatch')">Password do not match. </mat-error>
                  </mat-form-field> -->
                  <!-- <mat-error *ngIf="submitted && setPasswordControls.confirmPassword.hasError('required')">Password Required. </mat-error> -->
    
                  <mat-form-field appearance="outline">
                    <mat-label>Security Question</mat-label>
                    <mat-select formControlName="securityQuestion" id="set_password_security" required>
                      <mat-option>-- Select --</mat-option>
                      <mat-option *ngFor="let question of securityQuestions" value="{{question.id}}">{{question.questions}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="setPasswordControls.securityQuestion.hasError('required')">Security Question Required. </mat-error>
                  </mat-form-field>
    
                  <mat-form-field appearance="outline">
                    <mat-label>Answer</mat-label>
                    <input type="text" id="set_password_answer" formControlName="securityAnswer" matInput placeholder="Answer" required>
                    <mat-error *ngIf="setPasswordControls.securityAnswer.hasError('required')">Security Answer Required. </mat-error>
                  </mat-form-field>
    
                  <div class="btn-grid">
                    <button mat-raised-button id="set_password_submit" type="submit" class="btn-set-password">Set Password</button>
                  </div>
    
                </form>
              </div>
            </mat-card-content>
          </mat-card>
          <app-powered-by-footer></app-powered-by-footer>
        </div>
      </div>
    </div>
  </div>
</ion-content>
